import React from "react"
import {
	User as UserIcon,
	Lock as LockIcon,
	LogOut as LogOutIcon
} from "lucide-react"

import AuthService from "@/services/Auth"
import { inboxAppUrl } from "@/config/url"

const ICON_SIZE_IN_PIXELS = 20

type ProfileMenuItem = {
	label: string
	icon: React.ReactNode
	onClick: () => void
}

const useProfileMenuItems = () => {
	const handleOpenProfilePage = () => {
		window.open(`${inboxAppUrl.cpURL}/admin/account/profile`, "inbox_admin_page")
	}

	const handleOpenSecurityPage = () => {
		window.open(`${inboxAppUrl.cpURL}/admin/account/security`, "inbox_admin_page")
	}

	const handleLogout = async () => {
		await AuthService.logout("/signin")
	}

	const profileMenuAccountItems: ProfileMenuItem[] = [
		{
			label: "Meus dados",
			icon: <UserIcon size={ICON_SIZE_IN_PIXELS} />,
			onClick: handleOpenProfilePage
		},
		{
			label: "Segurança",
			icon: <LockIcon size={ICON_SIZE_IN_PIXELS} />,
			onClick: handleOpenSecurityPage
		},
		{
			label: "Sair",
			icon: <LogOutIcon size={ICON_SIZE_IN_PIXELS} />,
			onClick: handleLogout
		}
	]

	return {
		handleOpenProfilePage,
		handleOpenSecurityPage,
		handleLogout,
		profileMenuAccountItems
	}
}

export default useProfileMenuItems
